import * as Api from '@ViewModels';
import { createContentStateWithHtmlStringValue } from '../../../models/utils/richContentUtils';
import { PostContentType } from './types';

export const buildDraftContext = (postContent: string, postContentType: PostContentType): Api.AIContext => {
	const content = createContentStateWithHtmlStringValue(postContent).getRawRichTextContent();
	return postContentType === 'email'
		? ({ _type: 'EmailAIContext', body: content } as Api.EmailAIContext)
		: ({ _type: 'SocialMediaAIContext', content } as Api.SocialMediaAIContext);
};
